import { Injectable, EventEmitter } from "@angular/core";

/**
 * 刷新导航数据通知
 */
export interface RefreshNotification {
  /** 树类型名称数组，如果为空则全部刷新 */
  type?: string[];
  /** 数据刷新完成后，选中该条目 */
  selectNodePath?: string;
}

/**
 * 导航树（通知）服务
 * @remarks 方便控制器对左侧的导航树进行统一的控制
 */
@Injectable()
export class NavTreeService {

  get refresh(): EventEmitter<RefreshNotification> {
    return this._refresh;
  }

  private _refresh = new EventEmitter<RefreshNotification>();

}
